<template>
  <v-content style="padding-top: 90px;">
    <Navbar />
    <Sidebar />
    <div class="fill-height" style="background:#fff">
      <v-row justify="center" class="px-9 pt-4 pb-9" no-gutters>
        <v-col cols="12">
          <router-view />
        </v-col>
      </v-row>
    </div>
  </v-content>
</template>

<script>
import Navbar from '../components/core/Navbar'
import Sidebar from '../components/core/Sidebar'
export default {
  name: 'Main',
  components: { Navbar, Sidebar }
}
</script>
